<template>
    <div id="app" :class="'page-' + $router.currentRoute.name.toLowerCase()">
        <div id="wrapper" class="">
            <router-view :key="$route.fullPath"/>
        </div>

        <div class="internet-offline">
            Você está sem conexão com a internet. As informações carregadas no aplicativo podem estar desatualizadas.
            <button type="button" onclick="$('#app').fadeOut(1000); window.location.reload()">Atualizar</button>
        </div>

    </div>
</template>

<script>
import Top from './components/Top'

export default {
    name: 'App',
    components: {
        'Top': Top,
    },
    methods: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + " " + time;
        }    	
    }
}
</script>

<style>

    #app {


    }

    .current-page-cadastrarpedidos .internet-offline {
        display: none !important;
        z-index: -99999 !important;
        opacity: 0 !important;
    }

    .internet-offline {
        position: fixed;
        bottom: 0px;
        left: 0px;
        right: 0px;
        min-height: 40px;
        line-height: 16px;
        color: #fff;
        z-index: 100;
        background: red;
        padding: 8px;
        padding-right: 90px;
        font-size: 14px;
        display: none;

    }

    .internet-offline button {
        background: #fff;
        position: absolute;
        right: 10px;
        /*float: right;*/
        padding: 10px;
        bottom: 13px;
        /*margin-right: -80px;*/
        /*margin-top: -9%;*/
        border-radius: 6px;
        color: #000;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue